import { api } from "@/utils/axiosInterceptor";
import { BusinessProfileFormData, BusinessProfileType } from "@/types/businessProfile";

export const businessProfileApi = {
    updateBusinessProfile: async (businessId: string, profileData: BusinessProfileFormData): Promise<BusinessProfileType> => {
      try {
        const response = await api.put<BusinessProfileType>(
          `/business-profile?businessId=${businessId}`, 
          profileData
        );
  
        return response.data;
      } catch (error: any) {
        console.error("Business Profile Update Error:", error.response?.data || error.message);
        throw new Error(error.response?.data?.message || "Failed to update business profile");
      }
    },
  };
  